module.exports = __webpack_public_path__ + "static/media/17.5a46f03d.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/male/shoes/17.png
// module id = 1514
// module chunks = 0